interface SquiggleDividerProps {
  className?: string
}

const SquiggleDivider: React.FC<SquiggleDividerProps> = ({ className }) => (
  <>
    <img
      src="/images/squiggle-value-prop-mobile.svg"
      alt=""
      aria-hidden="true"
      className={`~block sm:~hidden ${className ?? ''}`}
    />
    <img
      src="/images/squiggle-value-prop-desktop.svg"
      alt=""
      aria-hidden="true"
      className={`~hidden sm:~block ${className ?? ''}`}
    />
  </>
)

export default SquiggleDivider
